const url = process.env.REACT_APP_API;

export default url;